import React, { useState, useEffect, useContext } from "react";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../themes/Colors";
import {
  AgencyDisplay,
  BrandDisplay,
  BuzzFeedControlDisplay,
  Menu,
  OffensesDisplay,
  ProductDisplay,
  StoreDisplay,
  ThirdPartyDisplay,
  UsersDisplay,
  VehicleDisplay,
  WebManagerDisplay,
  TasksDisplay,
} from "./components";

import {
  LoadingPopUp,
  ProfileHeader,
  ToastNotification,
} from "../common-components";
import { AuthContext } from "../../context/auth-context";
import { useNavigate } from "react-router-dom";

const Admin = () => {
  const { width, height } = useWindowDimensions();
  const [selectedDisplay, setSelectedDisplay] = useState(0);
  const [moduleSelected, setSelectedModule] = useState("USERS");
  const [toastPop, setToastPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popUpTitle, setPopUpTitle] = useState("");
  const [message, setMessage] = useState("");
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [shareAccount, setShareAccount] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  const [agencyRole, setAgencyRole] = useState(null);
  const [checkRun, setCheckRun] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const backGroundColorSelecto = (value) => {
    if (value === 0) {
      return colors.greenDark;
    } else if (value === 1) {
      return colors.greenDark;
    } else if (value === 2) {
      return colors.greenDark;
    } else if (value === 3) {
      return colors.greenDark;
    } else if (value === 4) {
      return colors.greenDark;
    } else if (value === 5) {
      return colors.greenDark;
    } else if (value === 6) {
      return colors.greenDark;
    }
  };
  const GetShareAccount = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getUserShareAccount",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: auth.customerUserData.userId,
            email: auth.customerUserData.email,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.shareAccount) {
        setLoading(false);
        setToastPop(true);
        setMessage("Created Share Account");
        setPopUpTitle("SUCCESS");
        setShareAccount(responseData.shareAccount);
        setCheckRun(true);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(
          "Could not create your share account please contact support"
        );
        setLoading(false);
        setCheckRun(true);
      }
    } catch (err) {
      setCheckRun(true);
    }
  };
  const ShareAccountRolesCheck = async () => {
    if (shareAccount) {
      await shareAccount.linkedRoles.map((role) =>
        role === "ADMIN" ? setAdminRole(true) : null
      );
      await shareAccount.linkedRoles.map((role) =>
        role === "AGENCY" ? setAgencyRole(true) : null
      );
      return {
        admin: adminRole,
        agency: agencyRole,
      };
    } else {
      setAdminRole(false);
      setAgencyRole(false);
    }
  };

  const GoToMobileApp = () => {
    navigate("/driversFriendMobile");
  };

  useEffect(() => {
    GetShareAccount();
    ShareAccountRolesCheck();
    if (shareAccount) {
      if (!adminRole) {
        navigate("/");
      }
    }
  }, [adminRole]);
  useEffect(() => {
    if (checkRun && !shareAccount && !adminRole) {
      if (
        !auth.isloggedIn ||
        auth.customerUserData.type === "Customer" ||
        auth.customerUserData.type === "Manager" ||
        auth.customerUserData.type === "Support" ||
        auth.customerUserData.type === "Investor"
      ) {
        // console.log("path check", admin.adminUserData.type);
        navigate("/");
      }
    }
  }, [checkRun]);
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);

        setTimeout(() => {
          setPopUpTitle("");
          setMessage("");
        }, 1000);
      }, 2000);
    }
  }, [toastPop]);
  return (
    <div
      style={{
        width: width,
        height: height,
        display: "flex",
        backgroundColor: colors.white,
        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <Menu
        onRefreshClick={() => setRefresh(refresh ? false : true)}
        selected={moduleSelected}
        onUserClick={() => {
          setSelectedDisplay(0);
          setSelectedModule("USERS");
        }}
        onVehicleClick={() => {
          setSelectedDisplay(1);
          setSelectedModule("VEHICLES");
        }}
        onBuzzClick={() => {
          setSelectedDisplay(1);
          setSelectedModule("BUZZ");
        }}
        onOffenseClick={() => {
          setSelectedDisplay(1);
          setSelectedModule("OFFENSES");
        }}
        onTaskClick={() => {
          setSelectedDisplay(4);
          setSelectedModule("TASKS");
        }}
        onWebClick={() => {
          setSelectedDisplay(6);
          setSelectedModule("WEB");
        }}
        onThirdPartyClick={() => {
          setSelectedDisplay(1);
          setSelectedModule("thirdParty");
        }}
        onAgencyClick={() => {
          setSelectedDisplay(1);
          setSelectedModule("AGENCY");
        }}
      />
      <div
        style={{
          flex: 1,
          height: "100%",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          backgroundColor: backGroundColorSelecto(selectedDisplay),
          transition: "backgroundColor 0.7s",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ProfileHeader
          backgroundColor={backGroundColorSelecto(selectedDisplay)}
          username={
            auth
              ? (
                  auth.customerUserData.firstName +
                  " " +
                  auth.customerUserData.lastName
                ).toUpperCase()
              : null
          }
          onMobileClick={() => GoToMobileApp()}
        />

        <div
          style={{
            height: "100%",
            maxHeight: 900,
            minHeight: 450,
            width: "100%",
            minWidth: 500,
            maxWidth: 1500,
            backgroundColor: colors.secondaryGrey,
            marginTop: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "top",
            overflow: "visible",
            position: "relative",
          }}
        >
          {moduleSelected === "USERS" ? (
            <ProductDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
          {/* {moduleSelected === "STORES" ? <StoreDisplay /> : null} */}
          {moduleSelected === "BRANDS" ? (
            <BrandDisplay refresh={refresh} />
          ) : null}
          {/* {moduleSelected === "USERS" ? <UsersDisplay /> : null} */}
          {moduleSelected === "VEHICLES" ? (
            <VehicleDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
          {moduleSelected === "BUZZ" ? (
            <BuzzFeedControlDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
          {moduleSelected === "WEB" ? (
            <WebManagerDisplay
              width={width}
              setLoading={setLoading}
              setMessage={setMessage}
              setToastPop={setToastPop}
              setPopUpTitle={setPopUpTitle}
              loading={loading}
              refresh={refresh}
            />
          ) : null}
          {moduleSelected === "thirdParty" ? (
            <ThirdPartyDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
          {moduleSelected === "OFFENSES" ? (
            <OffensesDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          ) : null}
          {moduleSelected === "TASKS" ? (
            <TasksDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
          {moduleSelected === "AGENCY" ? (
            <AgencyDisplay
              width={width}
              height={height}
              setToastPop={setToastPop}
              setMessage={setMessage}
              setLoading={setLoading}
              loading={loading}
              setPopUpTitle={setPopUpTitle}
              auth={auth}
              refresh={refresh}
            />
          ) : null}
        </div>
      </div>
      <ToastNotification
        display={toastPop}
        title={popUpTitle}
        mainTitle={popUpTitle}
        message={message}
        width={width}
      />
      <LoadingPopUp display={loading} />
    </div>
  );
};

export default Admin;
